var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  viewBox: "0 0 72 72",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M36 0c19.882 0 36 16.118 36 36S55.882 72 36 72 0 55.882 0 36 16.118 0 36 0m0 3C17.775 3 3 17.775 3 36s14.775 33 33 33 33-14.775 33-33S54.225 3 36 3m0 3c16.569 0 30 13.431 30 30S52.569 66 36 66 6 52.569 6 36 19.431 6 36 6m-8 18v24l20-12z"
})));
export default SvgGoogleDesktopPlay;